const ServiceSettings = () => {
	return <div>ServiceSettings</div>;
};

export default ServiceSettings;
